module.exports = __webpack_public_path__ + "static/media/15608489_10211602258121724_350383098_o.9db41de9.jpg";